import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    targetId: String, 
    caption: String,       
    width: String,
    url: String 
  }

  open(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const contentId = this.targetIdValue;
    const caption   = this.captionValue || "";
    const width     = this.widthValue || "80vw";
    const fileUrl   = this.urlValue;

    if (!contentId) {
      console.warn("⚠️ Aucun ID de contenu défini pour fancybox-popup.");
      return;
    }
 
    const popupTarget = document.getElementById(contentId);
    if (popupTarget) {
   
      const container = popupTarget.querySelector('.iframe-container');
       
      if (container && !container.querySelector('iframe')) {
        const iframe = document.createElement('iframe');
        iframe.src = fileUrl;
        iframe.style.width = '100%';
        iframe.style.height = '75vh';
        iframe.style.border = 'none';
        
        container.appendChild(iframe);
      }
    }

 
    if (window.Fancybox && typeof window.Fancybox.close === "function") {
      try { window.Fancybox.close(); } catch(_) {}
    }
 
    Fancybox.show([{
      src: `#${contentId}`,
      type: "inline",
      caption: caption,
      width: width,
      height: "auto"
    }]);
  }
}